module.exports = __webpack_public_path__ + "static/media/cloud2.67d5339b.svg";